import Lottie from 'lottie-react'
import { useMemo } from 'react'
import loadingAnimation from '@/assets/loading-animation.json'
import IdeyaTypography from '@/common/antd/ideya-typography'
import { selectTheme } from '@/features/setting/setting.slice'
import { useAppSelector } from '@/redux/hooks'
import { Theme } from '@/features/setting/setting.def'
import { getDarkToken, getLightToken } from '@/styles/antd/config-token/token'

export const IdeyaSpinner = () => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        style={{ width: '360px' }}
      />
    </div>
  )
}

export const IdeyaFullScreenSpinner = () => {
  const colorTheme = useAppSelector(selectTheme)
  const token = useMemo(
    () =>
      colorTheme === Theme.Dark ? getDarkToken() : getLightToken(),
    [colorTheme]
  )
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <IdeyaSpinner />
      <IdeyaTypography.Text style={{color: token.colorPrimaryText}}>System Checking...</IdeyaTypography.Text>
    </div>
  )
}